import { Component, OnInit } from '@angular/core';
import { UserService } from '@modules/user/user.service';
import { BaseComponent } from '@app/base/basecomponent';
import { Tenant } from '@models/user/tenant';
import { PersistenceService } from '@app/_services/persistence.service';
import { Router } from '@angular/router';
import { UserSettingLink } from '@app/_models/settings/user-settings';
import { User } from '@app/_models/user/user';
import { UserSettingService } from '@app/areas/usersetting/usersetting.service';
import { UserLanguage } from '@app/_enums/userLanguage';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'tenant-select',
  templateUrl: './tenant-select.component.html'
})

/**
 * Component for changing organization after user has logged in.
 */
export class TenantSelectComponent extends BaseComponent implements OnInit {

  public loading = true;
  public tenants: Tenant[];
  public filteredTenants: Tenant[];
  public form: UntypedFormGroup;

  public currentUser: User;

  constructor(
    private userService: UserService,
    private router: Router,
    private persistence: PersistenceService,
    private userSettingService: UserSettingService
  ) {
    super();
    this.form = this.formBuilder.group({
      search: ['']
    });
    this.form.get('search').valueChanges.subscribe(value => {
      this.filteredTenants = (this.tenants ?? []).filter(tenant => {
        return tenant.name?.toLowerCase()?.includes((value ?? '').toLowerCase());
      });
    });

    //this.translate.setDefaultLang('fi');
    this.translate.use(this.persistence.getLang());

    if (!this.authService.currentUserValue.multiTenantUser) {
      //When user is not a multi organization user, they are redirected.
      this.router.navigate(['/']);
    }
  }

  ngOnInit(): void {
    this.getUserTenants();

    this.currentUser = this.authService.currentUserValue;
  }


  private getUserTenants() {
    this.subscription.add(
      this.userService.getUserTenants().subscribe(data => {
        this.tenants = data;
        this.filteredTenants = data;
        this.loading = false;
      }, error => {
        this.alertService.error(error);
        this.loading = false;
      })
    );
  }


  chooseTenant(tenantID: number) {
    this.subscription.add(
      this.authService.switchTenant(tenantID).subscribe(data => {
        // When this local storage item is set, local storage items should be refreshed.
        this.persistence.set('avux-req-init', 1);

        // Change language if it differs from current language. Note that it is also possible to simply call POST request to
        // change it even when it has not been changed.
        const currentLang = localStorage.getItem('l-curLang');
        if(currentLang){
          let langSettings: UserSettingLink[] = [{
            userAccountId: this.currentUser.id,
            userSettingId: "userLanguage",
            currentVal: UserLanguage[currentLang]
          }];

          this.userSettingService.setUserSettings(langSettings).subscribe();
        }

        this.router.navigate(['/']);

      }, error => {
        this.alertService.error(error);
      })
    );
  }


  cancel() { }

}
